import script from "./MessageActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageActions.vue?vue&type=script&lang=ts&setup=true"

import "./MessageActions.vue?vue&type=style&index=0&id=85e8f548&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e8f548"]])

export default __exports__